import "core-js/modules/web.dom.iterable";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { changeWeek } from '@/components/_util/util';
export default {
  name: 'scatterChart',
  props: ['chart'],
  methods: {
    initScatterChart: function initScatterChart(data, reportType, factors) {
      var that = this;
      var text = '';

      switch (reportType) {
        case '11':
          text = '时';
          break;

        case '12':
          text = '日';
          break;

        case '15':
          text = '季';
          break;

        case '16':
          text = '年';
          break;

        case '14':
          text = '月';
          break;

        case '13':
          text = '周';
          break;
      }

      var schema = data.schemaData;
      var option = {
        color: ['#dd4444', '#fec42c'],
        legend: {
          top: 10,
          data: data.legendData,
          textStyle: {
            color: '#000',
            fontSize: 16
          }
        },
        grid: {
          left: '10%',
          right: '10%',
          top: '18%',
          bottom: '10%'
        },
        tooltip: {
          padding: 10,
          backgroundColor: '#222',
          borderColor: '#777',
          borderWidth: 1,
          formatter: function formatter(obj) {
            var value = obj.value;
            var date = '';

            switch (reportType) {
              case '11':
                date = value[0] + '时';
                break;

              case '12':
                date = value[0];
                break;

              case '15':
                date = value[0] + '季';
                break;

              case '14':
                date = value[0] + '月';
                break;

              case '13':
                var week = changeWeek(value[0]);
                date = '周 ' + week;
                break;
            }

            var str = '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">' + obj.seriesName + ' ' + date + '</div>';
            factors.forEach(function (element, i) {
              str += schema[i].text + '：' + value[i + 1] + "".concat(element.unitName ? "(".concat(element.unitName, ")") : '') + '<br>';
            });
            return str;
          }
        },
        xAxis: {
          type: 'value',
          name: text,
          nameGap: 16,
          nameTextStyle: {
            color: '#000',
            fontSize: 14
          },
          splitLine: {
            show: false
          },
          minInterval: text == '季' ? 1 : 0,
          axisLine: {
            lineStyle: {
              color: '#000'
            }
          }
        },
        yAxis: {
          type: 'value',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            color: '#000',
            fontSize: 16
          },
          axisLine: {
            lineStyle: {
              color: '#000'
            }
          },
          splitLine: {
            show: false
          }
        },
        // visualMap: [
        //   {
        //     show: false,
        //     left: 'right',
        //     top: '10%',
        //     dimension: 2,
        //     min: 0,
        //     max: 250,
        //     itemWidth: 30,
        //     itemHeight: 120,
        //     calculable: true,
        //     precision: 0.1,
        //     text: ['圆形大小：PM2.5'],
        //     textGap: 30,
        //     textStyle: {
        //       color: '#000'
        //     },
        //     inRange: {
        //       symbolSize: [0, 10]
        //     },
        //     outOfRange: {
        //       symbolSize: [0, 10],
        //       color: ['rgba(255,255,255,.2)']
        //     },
        //     controller: {
        //       inRange: {
        //         color: ['#c23531']
        //       },
        //       outOfRange: {
        //         color: ['#444']
        //       }
        //     }
        //   },
        //   {
        //     show: false,
        //     left: 'right',
        //     bottom: '5%',
        //     dimension: 6,
        //     min: 0,
        //     max: 50,
        //     itemHeight: 120,
        //     precision: 0.1,
        //     text: ['明暗：二氧化硫'],
        //     textGap: 30,
        //     textStyle: {
        //       color: '#000'
        //     },
        //     inRange: {
        //       colorLightness: [1, 0.5]
        //     },
        //     outOfRange: {
        //       color: ['rgba(255,255,255,.2)']
        //     },
        //     controller: {
        //       inRange: {
        //         color: ['#c23531']
        //       },
        //       outOfRange: {
        //         color: ['#444']
        //       }
        //     }
        //   }
        // ],
        series: data.seriesData
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};